
import React, { Component } from 'react';
import classnames from 'classnames';
import ModalInner from '../layoutItems/modalInner';
import { withLocalize } from 'react-localize-redux';
import { Translate } from "react-localize-redux";

class LeavingMarketingListPopup extends Component {
    render() {
        return (
            <ModalInner close={() => this.props.close()} title={`${this.props.translate(`Marketing.PopupHeader.Leaving${this.props.type}`)}`}>
                <div className="has-text-centered" style={{ paddingBottom: "2em" }}>
                    <p style={{ paddingBottom: "1em" }}>
                        <Translate id={`Marketing.PopupText.Leaving${this.props.type}1`} />
                    </p>
                    <p><Translate id={`Marketing.PopupText.Leaving${this.props.type}2`} /></p>
                    <p><Translate id={`Marketing.PopupText.Leaving3`} /></p>
                </div>
                <div className="modal-inner-buttons">
                    <button onClick={() => this.props.close()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Marketing.PopupButton.Stay" /></button>
                    <button onClick={() => this.props.saveAndLeave()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Marketing.PopupButton.SaveAndLeave" /></button>
                    <button onClick={() => this.props.leave()} className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}><Translate id="Marketing.PopupButton.Leave" /></button>
                </div>
            </ModalInner >
        )
    }
}

export default withLocalize(LeavingMarketingListPopup);